import create, { SetState, GetState, StoreApi } from 'zustand';
import { IUseStore } from './useStore.types';
import { resourceStore } from './partial-stores/resourceStore';

export const useStore = create<IUseStore>((set: SetState<IUseStore>, get: GetState<IUseStore>, api: StoreApi<IUseStore>) => ({
    ...resourceStore(set, get, api),
}));
